module.exports = __webpack_public_path__ + "img/icon-edit.616341f2.svg";